export const exteriorScenes = {
  exterior01: {
    name: "Main View",
    panorama: "/images/Exterior/Exterior01.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior01/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior01",
    hotspots: [
      {
        id: "to-exterior02",
        yaw: "40deg",
        pitch: "-5deg",
        label: "Drop Zone View",
        target: "exterior02",
        type: "arrow"
      },
      {
        id: "to-exterior03",
        yaw: "-37deg",
        pitch: "0deg",
        label: "Passage View 1",
        target: "exterior03",
        type: "arrow"
      },
      {
        id: "to-exterior17",
        yaw: "-17deg",
        pitch: "40deg",
        label: "Balcony View 5",
        target: "exterior17",
        type: "arrow"
      },
    ],
  },
  exterior02: {
    name: "Drop Zone View",
    panorama: "/images/Exterior/Exterior02.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior02/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior02",
    hotspots: [
      {
        id: "to-exterior06",
        yaw: "30deg",
        pitch: "0deg",
        label: "Passage View 4",
        target: "exterior06",
        type: "arrow"
      },
      {
        id: "to-exterior03",
        yaw: "-47deg",
        pitch: "0deg",
        label: "Passage View 1",
        target: "exterior03",
        type: "arrow"
      },
    ],
  },
  exterior03: {
    name: "Passage View 1",
    panorama: "/images/Exterior/Exterior03.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior03/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior03",
    hotspots: [
      {
        id: "to-exterior04",
        yaw: "-8deg",
        pitch: "0deg",
        label: "Passage View 2",
        target: "exterior04",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "2deg",
        pitch: "-3deg",
        label: "Passage View 3",
        target: "exterior05",
        type: "arrow"
      },
      {
        id: "to-exterior19",
        yaw: "-5deg",
        pitch: "40deg",
        label: "Balcony View 7",
        target: "exterior19",
        type: "arrow"
      },
      {
        id: "to-exterior18",
        yaw: "0deg",
        pitch: "30deg",
        label: "Balcony View 6",
        target: "exterior18",
        type: "arrow"
      },
    ],
  },
  exterior04: {
    name: "Passage View 2",
    panorama: "/images/Exterior/Exterior04.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior04/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior04",
    hotspots: [
      {
        id: "to-exterior12",
        yaw: "-5deg",
        pitch: "2deg",
        label: "Passage View 6",
        target: "exterior12",
        type: "arrow"
      },
      {
        id: "to-exterior03",
        yaw: "90deg",
        pitch: "0deg",
        label: "Passage View 1",
        target: "exterior03",
        type: "arrow"
      },
      {
        id: "to-exterior19",
        yaw: "-85deg",
        pitch: "70deg",
        label: "Balcony View 7",
        target: "exterior19",
        type: "arrow"
      },
      {
        id: "to-exterior18",
        yaw: "65deg",
        pitch: "70deg",
        label: "Balcony View 6",
        target: "exterior18",
        type: "arrow"
      },
    ],
  },
  exterior05: {
    name: "Passage View 3",
    panorama: "/images/Exterior/Exterior05.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior05/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior05",
    hotspots: [
      {
        id: "to-exterior06",
        yaw: "70deg",
        pitch: "-5deg",
        label: "Passage View 4",
        target: "exterior06",
        type: "arrow"
      },
      {
        id: "to-exterior07",
        yaw: "40deg",
        pitch: "0deg",
        label: "Gazebo View",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior08",
        yaw: "10deg",
        pitch: "0deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
      {
        id: "to-exterior13",
        yaw: "-20deg",
        pitch: "10deg",
        label: "Balcony View 1",
        target: "exterior13",
        type: "arrow"
      },
    ],
  },
  exterior06: {
    name: "Passage View 4",
    panorama: "/images/Exterior/Exterior06.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior06/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior06",
    hotspots: [
      {
        id: "to-exterior07",
        yaw: "130deg",
        pitch: "0deg",
        label: "Gazebo View",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "0deg",
        pitch: "0deg",
        label: "Passage View 3",
        target: "exterior05",
        type: "arrow"
      },
    ],
  },
  exterior07: {
    name: "Gazebo View",
    panorama: "/images/Exterior/Exterior07.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior07/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior07",
    hotspots: [
      {
        id: "to-exterior06",
        yaw: "-90deg",
        pitch: "0deg",
        label: "Passage View 4",
        target: "exterior06",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "-50deg",
        pitch: "0deg",
        label: "Passage View 3",
        target: "exterior05",
        type: "arrow"
      },
      {
        id: "to-exterior08",
        yaw: "40deg",
        pitch: "0deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
      {
        id: "to-exterior09",
        yaw: "60deg",
        pitch: "-10deg",
        label: "Garden View 2",
        target: "exterior09",
        type: "arrow"
      },
    ],
  },
  exterior08: {
    name: "Garden View 1",
    panorama: "/images/Exterior/Exterior08.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior08/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior08",
    hotspots: [
      {
        id: "to-exterior09",
        yaw: "170deg",
        pitch: "0deg",
        label: "Garden View 2",
        target: "exterior09",
        type: "arrow"
      },
      {
        id: "to-exterior07",
        yaw: "185deg",
        pitch: "0deg",
        label: "Gazebo View",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "200deg",
        pitch: "3deg",
        label: "Passage View 3",
        target: "exterior05",
        type: "arrow"
      },
      {
        id: "to-exterior10",
        yaw: "10deg",
        pitch: "-6deg",
        label: "Garden View 3",
        target: "exterior10",
        type: "arrow"
      },
      {
        id: "to-exterior11",
        yaw: "-40deg",
        pitch: "-3deg",
        label: "Passage View 5",
        target: "exterior11",
        type: "arrow"
      },
      {
        id: "to-exterior13",
        yaw: "-20deg",
        pitch: "15deg",
        label: "Balcony View 1",
        target: "exterior13",
        type: "arrow"
      },
      {
        id: "to-exterior14",
        yaw: "-70deg",
        pitch: "15deg",
        label: "Balcony View 2",
        target: "exterior14",
        type: "arrow"
      },
      {
        id: "to-exterior15",
        yaw: "-120deg",
        pitch: "65deg",
        label: "Balcony View 3",
        target: "exterior15",
        type: "arrow"
      },
      {
        id: "to-exterior16",
        yaw: "200deg",
        pitch: "40deg",
        label: "Balcony View 4",
        target: "exterior16",
        type: "arrow"
      },
    ],
  },
  exterior09: {
    name: "Garden View 2",
    panorama: "/images/Exterior/Exterior09.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior09/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior09",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "0deg",
        pitch: "-5deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "-90deg",
        pitch: "0deg",
        label: "Passage View 3",
        target: "exterior05",
        type: "arrow"
      },
      {
        id: "to-exterior07",
        yaw: "-120deg",
        pitch: "0deg",
        label: "Gazebo View",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior15",
        yaw: "-40deg",
        pitch: "55deg",
        label: "Balcony View 3",
        target: "exterior15",
        type: "arrow"
      },
      {
        id: "to-exterior14",
        yaw: "-15deg",
        pitch: "10deg",
        label: "Balcony View 2",
        target: "exterior14",
        type: "arrow"
      },
      {
        id: "to-exterior13",
        yaw: "5deg",
        pitch: "10deg",
        label: "Balcony View 1",
        target: "exterior13",
        type: "arrow"
      },
    ],
  },
  exterior10: {
    name: "Garden View 3",
    panorama: "/images/Exterior/Exterior10.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior10/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior10",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "-180deg",
        pitch: "-10deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
      {
        id: "to-exterior07",
        yaw: "-180deg",
        pitch: "0deg",
        label: "Gazebo View",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior16",
        yaw: "-160deg",
        pitch: "40deg",
        label: "Balcony View 4",
        target: "exterior16",
        type: "arrow"
      },
      {
        id: "to-exterior15",
        yaw: "-130deg",
        pitch: "60deg",
        label: "Balcony View 3",
        target: "exterior15",
        type: "arrow"
      },
      {
        id: "to-exterior14",
        yaw: "-90deg",
        pitch: "14deg",
        label: "Balcony View 2",
        target: "exterior14",
        type: "arrow"
      },
      {
        id: "to-exterior11",
        yaw: "-40deg",
        pitch: "-3deg",
        label: "Passage View 5",
        target: "exterior11",
        type: "arrow"
      },
      {
        id: "to-exterior12",
        yaw: "20deg",
        pitch: "0deg",
        label: "Passage View 6",
        target: "exterior12",
        type: "arrow"
      },
    ],
  },
  exterior11: {
    name: "Passage View 5",
    panorama: "/images/Exterior/Exterior11.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior11/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior11",
    hotspots: [
      {
        id: "to-exterior12",
        yaw: "120deg",
        pitch: "0deg",
        label: "Passage View 6",
        target: "exterior12",
        type: "arrow"
      },
      {
        id: "to-exterior13",
        yaw: "80deg",
        pitch: "10deg",
        label: "Balcony View 1",
        target: "exterior13",
        type: "arrow"
      },
      {
        id: "to-exterior14",
        yaw: "-10deg",
        pitch: "28deg",
        label: "Balcony View 2",
        target: "exterior14",
        type: "arrow"
      },
      {
        id: "to-exterior15",
        yaw: "-70deg",
        pitch: "58deg",
        label: "Balcony View 3",
        target: "exterior15",
        type: "arrow"
      },
      {
        id: "to-exterior16",
        yaw: "-90deg",
        pitch: "38deg",
        label: "Balcony View 4",
        target: "exterior16",
        type: "arrow"
      },
      {
        id: "to-exterior08",
        yaw: "-150deg",
        pitch: "-5deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
    ],
  },
  exterior12: {
    name: "Passage View 6",
    panorama: "/images/Exterior/Exterior12.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior12/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior12",
    hotspots: [
      {
        id: "to-exterior11",
        yaw: "-40deg",
        pitch: "-3deg",
        label: "Passage View 5",
        target: "exterior11",
        type: "arrow"
      },
      {
        id: "to-exterior04",
        yaw: "-5deg",
        pitch: "0deg",
        label: "Passage View 2",
        target: "exterior11",
        type: "arrow"
      },
      {
        id: "to-exterior08",
        yaw: "-80deg",
        pitch: "0deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
    ],
  },
  exterior13: {
    name: "Balcony View 1",
    panorama: "/images/Exterior/Exterior13.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior13/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior13",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "10deg",
        pitch: "-5deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
      {
        id: "to-exterior16",
        yaw: "40deg",
        pitch: "25deg",
        label: "Balcony View 4",
        target: "exterior16",
        type: "arrow"
      },
    ],
  },
  exterior14: {
    name: "Balcony View 2",
    panorama: "/images/Exterior/Exterior14.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior14/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior14",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "-20deg",
        pitch: "-15deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
    ],
  },
  exterior15: {
    name: "Balcony View 3",
    panorama: "/images/Exterior/Exterior15.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior15/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior15",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "-20deg",
        pitch: "-25deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
    ],
  },
  exterior16: {
    name: "Balcony View 4",
    panorama: "/images/Exterior/Exterior16.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior16/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior16",
    hotspots: [
      {
        id: "to-exterior08",
        yaw: "-20deg",
        pitch: "-15deg",
        label: "Garden View 1",
        target: "exterior08",
        type: "arrow"
      },
    ],
  },
  exterior17: {
    name: "Balcony View 5",
    panorama: "/images/Exterior/Exterior17.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior17/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior17",
    hotspots: [
      {
        id: "to-exterior01",
        yaw: "-20deg",
        pitch: "-5deg",
        label: "Main View",
        target: "exterior01",
        type: "arrow"
      },
    ],
  },
  exterior18: {
    name: "Balcony View 6",
    panorama: "/images/Exterior/Exterior18.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior18/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior18",
    hotspots: [
      {
        id: "to-exterior03",
        yaw: "-20deg",
        pitch: "-5deg",
        label: "Passage View 1",
        target: "exterior03",
        type: "arrow"
      },
    ],
  },
  exterior19: {
    name: "Balcony View 7",
    panorama: "/images/Exterior/Exterior19.jpg",
    thumbnail: "/images/tiles/Exterior/Exterior19/preview.jpg",
    tilesPath: "/images/tiles/Exterior/Exterior19",
    hotspots: [
      {
        id: "to-exterior03",
        yaw: "20deg",
        pitch: "-5deg",
        label: "Passage View 1",
        target: "exterior03",
        type: "arrow"
      },
    ],
  },
};

export const interiorScenes = {
  interior01: {
    name: "DRG Hall",
    panorama: "/images/Interior/Interior01.jpg",
    thumbnail: "/images/tiles/Interior/Interior01/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior01",
    hotspots: [
      {
        id: "to-interior02",
        yaw: "40deg",
        pitch: "0deg",
        label: "Temple",
        target: "interior02",
        type: "arrow"
      },
      {
        id: "to-interior03",
        yaw: "70deg",
        pitch: "0deg",
        label: "Dining",
        target: "interior03",
        type: "arrow"
      },
      {
        id: "to-interior04",
        yaw: "110deg",
        pitch: "-8deg",
        label: "Kitchen",
        target: "interior04",
        type: "arrow"
      },
      {
        id: "to-interior05",
        yaw: "-80deg",
        pitch: "0deg",
        label: "Master Bedroom 1",
        target: "interior05",
        type: "arrow"
      },
    ],
  },
  interior02: {
    name: "Temple",
    panorama: "/images/Interior/Interior02.jpg",
    thumbnail: "/images/tiles/Interior/Interior02/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior02",
    hotspots: [
      {
        id: "to-interior04",
        yaw: "190deg",
        pitch: "-9deg",
        label: "Kitchen",
        target: "interior04",
        type: "arrow"
      },
      {
        id: "to-interior03",
        yaw: "230deg",
        pitch: "-25deg",
        label: "Dining",
        target: "interior03",
        type: "arrow"
      },
      {
        id: "to-interior01",
        yaw: "280deg",
        pitch: "0deg",
        label: "DRG Hall",
        target: "interior01",
        type: "arrow"
      },
    ],
  },
  interior03: {
    name: "Dining",
    panorama: "/images/Interior/Interior03.jpg",
    thumbnail: "/images/tiles/Interior/Interior03/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior03",
    hotspots: [
      {
        id: "to-interior06",
        yaw: "50deg",
        pitch: "0deg",
        label: "Master Bedroom 2",
        target: "interior06",
        type: "arrow"
      },
      {
        id: "to-interior07",
        yaw: "70deg",
        pitch: "0deg",
        label: "Guest Bedroom",
        target: "interior07",
        type: "arrow"
      },
      {
        id: "to-interior05",
        yaw: "-80deg",
        pitch: "0deg",
        label: "Master Bedroom 1",
        target: "interior05",
        type: "arrow"
      },
      {
        id: "to-interior01",
        yaw: "-40deg",
        pitch: "0deg",
        label: "DRG Hall",
        target: "interior01",
        type: "arrow"
      },
    ],
  },
  interior04: {
    name: "Kitchen",
    panorama: "/images/Interior/Interior04.jpg",
    thumbnail: "/images/tiles/Interior/Interior04/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior04",
    hotspots: [
      {
        id: "to-interior05",
        yaw: "87deg",
        pitch: "0deg",
        label: "Master Bedroom 1",
        target: "interior05",
        type: "arrow"
      },
      {
        id: "to-interior01",
        yaw: "130deg",
        pitch: "0deg",
        label: "DRG Hall",
        target: "interior01",
        type: "arrow"
      },
      {
        id: "to-interior02",
        yaw: "190deg",
        pitch: "0deg",
        label: "Temple",
        target: "interior02",
        type: "arrow"
      },
      {
        id: "to-interior06",
        yaw: "-108deg",
        pitch: "5deg",
        label: "Master Bedroom 2",
        target: "interior06",
        type: "arrow"
      },
      {
        id: "to-interior07",
        yaw: "-95deg",
        pitch: "-5deg",
        label: "Guest Bedroom",
        target: "interior07",
        type: "arrow"
      },
    ],
  },
  interior05: {
    name: "Master Bedroom 1",
    panorama: "/images/Interior/Interior05.jpg",
    thumbnail: "/images/tiles/Interior/Interior05/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior05",
    hotspots: [
      {
        id: "to-interior01",
        yaw: "-105deg",
        pitch: "0deg",
        label: "DRG Hall",
        target: "interior01",
        type: "arrow"
      },
    ],
  },
  interior06: {
    name: "Master Bedroom 2",
    panorama: "/images/Interior/Interior06.jpg",
    thumbnail: "/images/tiles/Interior/Interior06/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior06",
    hotspots: [
      {
        id: "to-interior04",
        yaw: "92deg",
        pitch: "0deg",
        label: "Kitchen",
        target: "interior04",
        type: "arrow"
      },
    ],
  },
  interior07: {
    name: "Guest Bedroom",
    panorama: "/images/Interior/Interior07.jpg",
    thumbnail: "/images/tiles/Interior/Interior07/preview.jpg",
    tilesPath: "/images/tiles/Interior/Interior07",
    hotspots: [
      {
        id: "to-interior04",
        yaw: "85deg",
        pitch: "0deg",
        label: "Kitchen",
        target: "interior04",
        type: "arrow"
      },
    ],
  },
};

export const amenitiesScenes = {
  amenities01: {
    name: "Jula Area",
    panorama: "/images/Amenities/Amenities01.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities01/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities01",
    hotspots: [
      {
        id: "to-amenities02",
        yaw: "160deg",
        pitch: "0deg",
        label: "Conference Area",
        target: "amenities02",
        type: "arrow"
      },
      {
        id: "to-amenities03",
        yaw: "30deg",
        pitch: "0deg",
        label: "Foyer Area",
        target: "amenities03",
        type: "arrow"
      },
      {
        id: "to-amenities06",
        yaw: "-55deg",
        pitch: "0deg",
        label: "Banquet Hall",
        target: "amenities06",
        type: "arrow"
      },
    ],
  },
  amenities02: {
    name: "Conference Area",
    panorama: "/images/Amenities/Amenities02.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities02/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities02",
    hotspots: [
      {
        id: "to-amenities01",
        yaw: "60deg",
        pitch: "-4deg",
        label: "Jula Area",
        target: "amenities01",
        type: "arrow"
      },
      {
        id: "to-amenities03",
        yaw: "75deg",
        pitch: "-4deg",
        label: "Foyer Area",
        target: "amenities03",
        type: "arrow"
      },
      {
        id: "to-amenities06",
        yaw: "45deg",
        pitch: "-4deg",
        label: "Banquet Hall",
        target: "amenities06",
        type: "arrow"
      },
      {
        id: "to-amenities05",
        yaw: "-100deg",
        pitch: "-4deg",
        label: "Gym",
        target: "amenities05",
        type: "arrow"
      },
      {
        id: "to-amenities04",
        yaw: "-120deg",
        pitch: "-4deg",
        label: "Indoor Game",
        target: "amenities04",
        type: "arrow"
      },
    ],
  },
  amenities03: {
    name: "Foyer Area",
    panorama: "/images/Amenities/Amenities03.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities03/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities03",
    hotspots: [
      {
        id: "to-amenities01",
        yaw: "-55deg",
        pitch: "0deg",
        label: "Jula Area",
        target: "amenities01",
        type: "arrow"
      },
      {
        id: "to-amenities06",
        yaw: "-90deg",
        pitch: "0deg",
        label: "Banquet Hall",
        target: "amenities06",
        type: "arrow"
      },
    ],
  },
  amenities04: {
    name: "Indoor Game",
    panorama: "/images/Amenities/Amenities04.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities04/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities04",
    hotspots: [
      {
        id: "to-amenities02",
        yaw: "-90deg",
        pitch: "0deg",
        label: "Conference Area",
        target: "amenities02",
        type: "arrow"
      },
      {
        id: "to-amenities05",
        yaw: "100deg",
        pitch: "0deg",
        label: "Gym",
        target: "amenities05",
        type: "arrow"
      },
    ],
  },
  amenities05: {
    name: "Gym",
    panorama: "/images/Amenities/Amenities05.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities05/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities05",
    hotspots: [
      {
        id: "to-amenities04",
        yaw: "-20deg",
        pitch: "0deg",
        label: "Indoor Game",
        target: "amenities04",
        type: "arrow"
      },
    ],
  },
  amenities06: {
    name: "Banquet Hall",
    panorama: "/images/Amenities/Amenities06.jpg",
    thumbnail: "/images/tiles/Amenities/Amenities06/preview.jpg",
    tilesPath: "/images/tiles/Amenities/Amenities06",
    hotspots: [
      {
        id: "to-amenities01",
        yaw: "-30deg",
        pitch: "0deg",
        label: "Jula Area",
        target: "amenities01",
        type: "arrow"
      },
      {
        id: "to-amenities02",
        yaw: "-10deg",
        pitch: "0deg",
        label: "Conference Area",
        target: "amenities02",
        type: "arrow"
      },
    ],
  },
};

export const buildingViews = [
  {
    day: "/images/HomeImage/DAY01.jpg",
    night: "/images/HomeImage/NIGHT01.jpg",
  },
  {
    day: "/images/HomeImage/DAY02.jpg",
    night: "/images/HomeImage/NIGHT02.jpg",
  },
  {
    day: "/images/HomeImage/DAY03.jpg",
    night: "/images/HomeImage/NIGHT03.jpg",
  },
  {
    day: "/images/HomeImage/DAY04.jpg",
    night: "/images/HomeImage/NIGHT04.jpg",
  },
];

export const exteriorTourOrder = ["exterior01", "exterior02", "exterior03", "exterior04", "exterior05", "exterior06", "exterior07", "exterior08", "exterior09", "exterior10", "exterior11", "exterior12", "exterior13", "exterior14", "exterior15", "exterior16", "exterior17", "exterior18", "exterior19"];

export const interiorTourOrder = ["interior01", "interior02", "interior03", "interior04", "interior05", "interior06", "interior07"];

export const amenitiesTourOrder = ["amenities01", "amenities02", "amenities03", "amenities04", "amenities05", "amenities06"];

export const brochure = "/images/Brochure.pdf";

export const video = "/images/Walkthrough.mp4";

export const images = [
  "/images/albums/Image1.jpg",
  "/images/albums/Image2.jpg",
  "/images/albums/Image3.jpg",
  "/images/albums/Image4.jpg",
  "/images/albums/Image5.jpg",
  "/images/albums/Image6.jpg",
  "/images/albums/Image7.jpg",
  "/images/albums/Image8.jpg",
  "/images/albums/Image9.jpg",
  "/images/albums/Image10.jpg",
  "/images/albums/Image11.jpg",
  "/images/albums/Image12.jpg",
  "/images/albums/Image13.jpg",
  "/images/albums/Image14.jpg",
  "/images/albums/Image15.jpg",
  "/images/albums/Image16.jpg"
]

export const floorPlan = [
  "/images/FloorPlan/Floor1.jpg",
  "/images/FloorPlan/Floor2.jpg",
  "/images/FloorPlan/Floor3.jpg",
  "/images/FloorPlan/Floor4.jpg"
]